<template>
  <v-container>
    <h2 style="color:gray">Cài Đặt Lớp Học</h2>
    <v-divider class="my-3"></v-divider>
    <v-row class="py-3">
      <v-col cols="12">
        <v-checkbox
          v-model="policies"
          value="view-class-group"
          :label="'Cho phép ' + roleName + ' thiết lập lớp học'"
          hide-details
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- lớp học -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          v-model="policies"
          value="view-class-list"
          :label="'Cho phép ' + roleName + ' xem danh sách sách lớp'"
          hide-details
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-new-class"
          :label="'Cho phép ' + roleName + ' thêm mới lớp học'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-class-info"
          :label="'Cho phép ' + roleName + ' cập nhật thông tin lớp học'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="delete-class"
          :label="'Cho phép ' + roleName + ' xóa lớp'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="add-student-extraClass"
          :label="'Cho phép ' + roleName + ' thêm học sinh vào lớp học (bổ trợ)'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- sổ điểm -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-class-mark"
          :label="'Cho phép ' + roleName + ' xem điểm lớp học'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- nhập điểm -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="update-class-mark"
          :label="'Cho phép ' + roleName + ' nhập điểm lớp học'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>

      <!-- sổ ghi đầu bài -->
      <v-col cols="12">
        <v-divider></v-divider>
      </v-col>
      <v-col cols="12" md="6">
        <v-checkbox
          hide-details
          value="view-class-note"
          :label="'Cho phép ' + roleName + ' xem sổ ghi đầu bài'"
          v-model="policies"
          class="ma-0 pa-0"
        ></v-checkbox>
      </v-col>
    </v-row>
    <v-divider class="my-3"></v-divider>
    <v-card-actions class="mt-4">
      <v-spacer></v-spacer>
      <v-btn color="primary" text class="mx-5" @click="reset()">Đặt lại</v-btn>
      <v-btn color="primary" @click="save()">Lưu</v-btn>
    </v-card-actions>
  </v-container>
</template>

<script>
import mixins from './helper/mixins'
export default {
  mixins: [mixins]
}
</script>
